module.exports = "dist/ba3dcd8903e3d0af5de7792777f8ae0d.woff";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/fonts/roboto/Roboto-Regular.woff
// module id = 213
// module chunks = 0